import { Component, input, TemplateRef, ContentChild } from '@angular/core';

@Component({
  selector: 'app-tab-item',
  imports: [],
  template: '<ng-content></ng-content>',
  styles: []
})
export class TabItemComponent {
  id = input<string>('');
  label = input<string>('');
  icon = input<string>('');
  disabled = input<boolean>(false);
  badge = input<string>('');
  badgeColor = input<string>('');

  @ContentChild('tabContent') contentTemplate?: TemplateRef<any>;
}

